import { NavLink, Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { NAV_LINKS } from "@/config/site";
import { BrandLogo } from "@/components/layout/BrandLogo";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

export function SiteHeader() {
  const waUrl = buildStockWhatsAppUrl();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-nm-border bg-nm-bg/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <div className="flex items-center gap-8">
          <BrandLogo />
          <nav aria-label="Navigasi utama" className="hidden lg:block">
            <ul className="flex items-center gap-1">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    end={link.to === "/"}
                    data-testid={`nav-link-${link.to}`}
                    className={({ isActive }) =>
                      `rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
                        isActive
                          ? "text-nm-red"
                          : "text-nm-muted hover:text-nm-text"
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/produk"
            data-testid="header-catalog-cta"
            className="inline-flex h-10 items-center justify-center rounded-lg bg-nm-red px-3 text-sm font-semibold text-white transition-colors hover:bg-nm-red-hover sm:px-4"
          >
            Katalog Produk
          </Link>
          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-whatsapp"
            aria-label="Cek Stok via WhatsApp"
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-nm-border text-wa transition-colors hover:bg-nm-surface2"
          >
            <MessageCircle className="h-5 w-5" />
          </a>
        </div>
      </div>
    </header>
  );
}
